import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { StepFunctions } from "../joyrideSteps";
import { useState } from "react";
import StartStep from "./StartStep";
import { useTranslation } from "react-i18next";

const WorkScheduleStep: React.FC<StepFunctions> = () => {
    const { t } = useTranslation();
    const [showStartStep, setShowStartStep] = useState(false);
    const handleButtonClick = () => setShowStartStep(true);

    return (
        <>
            {showStartStep ? (
                <StartStep setShowStartStep={setShowStartStep} />
            ) : (
                <Row>
                    <Col xs={11}>
                        <p className="mb-0 fs-7">
                            {t("Fill in the required fields marked with an asterisk")} (
                            <span className="text-danger">*</span>) {t("and")}{" "}
                            <span className="fs-normal fw-bold fs-7">{t('click \"Save\"')}</span>
                        </p>
                    </Col>
                    <Col xs={1} className="p-0 text-center">
                        <Button variant="link" className="p-0" onClick={handleButtonClick}>
                            <i className="bi bi-x-lg "></i>
                        </Button>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default WorkScheduleStep;
